import type { ProjectUpgradeFeeTaxTypeApi } from 'api-typings/projects/projects';
import type { CurrencyCode } from '../currencies';
import { generateCurrencyObject } from '../currencies';
import type { BidUpgradeFees } from './bid-upgrade-fees.model';

export interface GenerateBidUpgradeFeesOptions {
  readonly currencyCode: CurrencyCode;
  readonly highlightPrice?: number;
  readonly sealedPrice?: number;
  readonly freeHighlight?: boolean;
  readonly taxType?: ProjectUpgradeFeeTaxTypeApi;
}

// TODO: T267853 - Generate BidUpgradeFees objects for different countries
export function generateBidUpgradeFeesObject({
  currencyCode,
  highlightPrice = 1.1,
  sealedPrice = 1.1,
  freeHighlight = false,
  taxType,
}: GenerateBidUpgradeFeesOptions): BidUpgradeFees {
  const currency = generateCurrencyObject(currencyCode);

  return {
    id: currency.id,
    currency,
    highlightPrice,
    sealedPrice,
    freeHighlight,
    taxType,
  };
}
